/* jshint ignore:start */

var DictionaryManager = (function($) {
    // console.log("llamada a config idioma");
    var instance;

    function init() {

        var _$dictionaryWordLink,
            _$dictionaryNoWordsLink,
            _dictionaryWordSelector,
            _dictionaryWordClass;

        function filterLetters(letter)
        {
            var letterWord;

            if (letter === 'Todas') {
                $('.js-dictionary-word').show();
            } else {
                $('.js-dictionary-word').each(function () {
                    letterWord = $(this).data('letter');

                    if (letterWord === letter) {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                });
            }
        }


        return {
            initCommon: function() {
                _dictionaryWordSelector = '.js-dictionary-letter-filter';
                _dictionaryWordClass = 'dictionary__letter--selected';

                _$dictionaryWordLink.on('click', function (e) {
                    e.preventDefault();

                    $(_dictionaryWordSelector).removeClass(_dictionaryWordClass);

                    $(this).closest(_dictionaryWordSelector).toggleClass(_dictionaryWordClass);

                    filterLetters($(this).data('filter'));
                });

                _$dictionaryNoWordsLink.on('click', function(e) {
                    e.preventDefault();
                })
            },


            init: function() {
                _$dictionaryWordLink = $('.js-dictionary-letter-filter .js-dictionary-word-link');
                _$dictionaryNoWordsLink = $('.js-letter-no-words .js-dictionary-word-link');
                if (_$dictionaryWordLink.length || _$dictionaryNoWordsLink.length) {
                    // console.log('más cursos inittttt');
                    this.initCommon();
                }
            }
        };
    }


    return {

        getInstance: function(){

            if (!instance){
                instance = init();
            }

            return instance;
        }
    };
})(jQuery);
/* jshint ignore:end */

